import React, { FC } from 'react';
import Chart from 'react-apexcharts';
import { useQuery } from '@apollo/client';
import { GET_PRODUCT_Trends } from '../../../graphql/admin_queries';
import EmptyPageLoader from '../../../components/EmptyPageLoader';

type GetDateData = {
  count: number;
  month: string;
  monthIndex: number;
}
type GetAdminProductTrends = {
  data: {
    apartmentSearch: Array<GetDateData>;
    preRentGuarantee: Array<GetDateData>;
    rentGuarantee: Array<GetDateData>;
    rentPayment: Array<GetDateData>;
  }
};

const ProductAnalysisTrends: FC = () => {
  //
  const { data: response, loading } = useQuery<
    {getAdminProductTrends: GetAdminProductTrends}>(GET_PRODUCT_Trends);
  const chartInfo = response?.getAdminProductTrends?.data;

  const getChartData = (key: keyof GetAdminProductTrends['data']) => {
    if (!chartInfo || !chartInfo[key] || !chartInfo[key].length) {
      return [0, 0, 0, 0, 0, 0, 0, 0];
    }
    return chartInfo[key].map((stat) => stat.count);
  };
  const colors = ['#00B2A9', '#FCE300', '#5941A9', '#000000'];
  const data = {
    options: {
      chart: {
        id: 'basic-bar',
      },
      legend: {
        show: false,
      },
      stroke: {
        curve: 'smooth' as any,
        lineCap: 'round' as any,
      },
      colors,
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      },
      yaxis: {
        // min: 0,
        // max: 600,
        // stepSize: 100,
      },
    },
    series: [
      {
        name: 'Pre-rent Guarantee',
        data: getChartData('preRentGuarantee'),
      },
      {
        name: 'Rent Guarantee',
        data: getChartData('rentGuarantee'),
      },
      {
        name: 'Rent Payment',
        data: getChartData('rentPayment'),
      },
      {
        name: 'Apartment Search',
        data: getChartData('apartmentSearch'),
      },
    ],
  };

  return (
    <>
      <div className="product-analysis-trends">
        <div className="product-analysis-trends__header">
          <h5>Total sales</h5>
          <div className="analysis-trends__legends">
            {data.series.map((series, index) => (
              <div className="analysis-trends__legend">
                <span style={{ backgroundColor: colors[index] }} />
                {series.name}
              </div>
            ))}

          </div>
        </div>
        <div className="product-chart">
          <Chart
            options={data?.options}
            series={data?.series}
            type="line"
            width="100%"
            height={600}
          />
          {loading && (
            <div className="loader">
              <EmptyPageLoader />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductAnalysisTrends;
